import api from '@pray/shared/utils/api';

import type { SaveGroupParams } from './postCreateGroup';
import type { SeedGroupDetailResponse } from './types';

const GROUPS_URL = '/web/studio/admin/seed-emails/groups';

/**
 * Saves a group. `seed_ids` replaces the membership: what the editor sends is what a run reaches,
 * so an unticked row leaves the group.
 */
export async function putGroup(groupId: string, { name, description = null, seedIds }: SaveGroupParams) {
  const res = await api.executePutRequest<{ data: SeedGroupDetailResponse }>(`${GROUPS_URL}/${groupId}`, {
    name,
    description,
    seed_ids: seedIds,
  });
  return res.data.data;
}
